import { CLEAR_PAGE } from '../base/types';
import { FETCH_FEATURES, CREATE_FEATURE, UPDATE_FEATURE, DELETE_FEATURE } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const featuresReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_FEATURES}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_FEATURES}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isLoaded: true,
      };
    case `${FETCH_FEATURES}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_FEATURE}_FULFILLED`:
      return {
        ...state,
        data: [...state.data, payload],
      };
    case `${UPDATE_FEATURE}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };
    case `${DELETE_FEATURE}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'features' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default featuresReducer;
